import { isEmpty, extend, cloneDeep } from 'lodash'
import React, { Component } from 'react'
import Product from '../components/Product'
import { inject, observer } from 'mobx-react'
import hash from 'object-hash'
import { toJS } from 'mobx'

@inject('ui')
@observer
class ProductRenderType extends Component {
  state = {
    qty: 1,
  }

  onOpenCustomizeModal = product => {
    if(!isEmpty(product.config)) {
      const { ui } = this.props
      ui.openCustomizeModal(product)
    }
  }

  onCloseCustomizeModal = () => {
    const { ui } = this.props
    ui.closeCustomizeModal()
  }

  setQty = qty => {
    this.setState({
      qty,
    })
  }

  setValue = value => {
    this.setState({
      value,
    })
  }

  render() {
    const { brain } = this.props;
    let product = this.props.data;
    if (!product) return null;

    // if we have optional config from contentful, bring it up a level
    if (product.config && product.config.config) {
      product.config = product.config.config;
    }

    if (brain) {
      product = extend(product, brain.products.find(brainProduct => brainProduct.slug === product.slug));
    }

    // todo: these defaults should come from the server we are
    //  adding them here for now to keep moving.
    if (!product.defaultConfigHash && product.config) {
      if (product.catering) {
        product.config.headcount.totalHeadcount = product.config.headcount.minHeadcount
      }
      else {
        // make sure we have a default base set
        // todo: can probably remove this at some point it should be set from
        // the backend now
        if (product.config.base && product.config.base.length) {
          const foundDefaultBase = product.config.base.find(base => base.qty > 0);
          if (!foundDefaultBase) {
            product.config.base[0].qty = 1;
          }
        }
      }
      product.defaultConfigHash = hash(toJS(product).config)
      // use clone deep so we break the copy by reference association
      product.defaultConfig = cloneDeep(toJS(product).config)
      product.basePrice = product.price
    }

    return (
      <>
        <Product product={product} onOpenCustomizeModalClicked={this.onOpenCustomizeModal} />
      </>
    )
  }
}

export default ProductRenderType
